
import * as React from 'react';
import {
  ISelection
} from 'office-ui-fabric-react/lib/Selection';
import { asAsync } from '../../utilities/components/Async';
import { withCurrentItemSet, IDecorateWithCurrentItemSetProps } from '../decorators/selectors';
import {
  connectInvocationAction, IConnectedToInvocationProps, IDecorateConnectToInvocationActionProps
} from '../decorators/connectToInvocationAction';
import { ItemDefaultClickAction } from '../actions/defaultClick/DefaultClickAction';
import { IItemSetTilesListProps } from '../itemSetTilesList/ItemSetTilesList';
import { withItemSetSelection, IDecorateConnectToSelectionProps } from '../decorators/connectToSelection';
import { withPageLoadTracker, IDecorateWithPageLoadTrackerProps } from '../decorators/withPageLoadTracker';
import { asLayout, ILayoutProps, IDecorateAsLayoutProps } from '../layoutManager/LayoutManager';
import { connectToItemCache } from '../decorators/connectToItemCache';
import { tilesLayoutControl } from '../../controls/tilesLayoutControl';
import { IItemCache } from '../../models/IItemCacheObserver';
import { tilesLayoutType } from './TilesLayoutTypeFacet';

const AsyncTilesList = asAsync(async () => (
  await import(/* webpackChunkName: 'itemsettileslist' */'../itemSetTilesList/ItemSetTilesList')
).ItemSetTilesList);

const InvokableTilesList = connectInvocationAction(ItemDefaultClickAction, (
  invocationProps: IConnectedToInvocationProps
): Pick<IItemSetTilesListProps, 'onItemInvoked' | 'onItemContextMenu'> => {
  return {
    onItemInvoked: invocationProps.onItemInvoked,
    onItemContextMenu: invocationProps.onItemContextMenu
  };
})(AsyncTilesList);

export type IAsyncTilesListWithSelectionProps =
  IDecorateConnectToSelectionProps<
  IDecorateConnectToInvocationActionProps<
  IItemSetTilesListProps,
  Pick<IItemSetTilesListProps, 'onItemInvoked' | 'onItemContextMenu'>,
  {}
  >,
  Pick<IItemSetTilesListProps, 'selection'>, {}>;

export const AsyncTilesListWithSelection: React.ComponentType<IAsyncTilesListWithSelectionProps> =
  withItemSetSelection((selection: ISelection): Pick<IItemSetTilesListProps, 'selection'> => {
    return {
      selection: selection
    };
  })(InvokableTilesList);

const PageLoadTilesList = withPageLoadTracker([])(AsyncTilesListWithSelection);

const PageLoadTilesListLayout = asLayout(tilesLayoutType)(PageLoadTilesList);

export type ITilesLayoutProps = IDecorateAsLayoutProps<
  IDecorateWithCurrentItemSetProps<
  IDecorateWithPageLoadTrackerProps<
  IAsyncTilesListWithSelectionProps>>>;

export const TilesLayout: React.ComponentType<ITilesLayoutProps> = withCurrentItemSet()(
  connectToItemCache((itemCache: IItemCache, props: {
    itemKey: string;
  }): Pick<ILayoutProps, 'isAvailable'> => {
    const {
      itemKey
    } = props;
    const controlHandler = itemCache.demandItemFacet(tilesLayoutControl, itemKey);
    const {
      isAvailable = true
    } = tilesLayoutControl.evaluate(controlHandler)(itemCache, {
      itemKey: itemKey
    });

    return {
      isAvailable: isAvailable
    };
  })(PageLoadTilesListLayout)
);
